import React from 'react';

import type { ProxyTypeEnum } from 'venn-api';

import LagInput from './LagInput';
import { DesmoothingLagHelpText } from './DesmoothingLagHelpText';
import { typeSupportsDesmooth } from './utils';
import type { FundToBulkProxy, FundToProxy } from '../types';
import type { BulkPickerDetailedProxyMetadata } from '../../../hooks/useProxyDataQuery';

interface DesmoothingLagProps {
  investments: (FundToProxy | FundToBulkProxy)[];
  selectedProxyType?: ProxyTypeEnum;
  numLags?: number;
  suggestedNumLags?: number;
  onLagUpdate: (numLags: number) => void;
  proxyData?: BulkPickerDetailedProxyMetadata;
  inputClassName?: string;
  helpTextClassName?: string;
  variant?: 'stacked' | 'inline';
}

export const DesmoothingLag = ({
  investments,
  selectedProxyType,
  numLags,
  suggestedNumLags,
  onLagUpdate,
  proxyData,
  inputClassName,
  helpTextClassName,
  variant,
}: DesmoothingLagProps) => {
  const singleProxy = investments.length === 1;
  const customNumLags = numLags || suggestedNumLags;

  if (!selectedProxyType || !typeSupportsDesmooth(selectedProxyType)) {
    return null;
  }

  if (singleProxy) {
    return (
      <LagInput
        frequency={proxyData?.unproxiedFrequency ?? investments[0]!.returnFrequency}
        onLagUpdate={onLagUpdate}
        suggestedNumLags={suggestedNumLags}
        numLags={customNumLags ?? 0}
        inputClassName={inputClassName}
        variant={variant}
      />
    );
  }

  return <DesmoothingLagHelpText className={helpTextClassName} />;
};
